import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { Grid, Typography } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { fetchNews, fetchMoreNews } from 'src/core/redux/action/newsAction'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import Page from 'src/shared/Page/Page'
import NewsCard from 'src/shared/News/NewsCard'
import NewsCardFeatured from 'src/shared/News/NewsCardFeatured'
import NewsCategoriesFilter from 'src/shared/CategoriesFilter/NewsCategoriesFilter'
import { debounce } from 'ts-debounce'
import autobind from 'autobind-decorator'
import Btn from 'src/shared/Btn/Btn'

const paginateName = 'news';
const paginateAction = fetchNews;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

class News extends React.Component<IProps, {}> {

  componentDidMount(){
    const {promisesWithProgress, updateObjectCriteria} = this.props
    promisesWithProgress(updateObjectCriteria({category_actu: 'NOTeconomique', is_public: '', is_private: ''}))
  }

  render() {
    const {t, news, totalSize, isFetching} = this.props
    return (
      <Page>
        
        {news && 
          <Grid container>
            <Grid item xs={12}>
              <NewsCategoriesFilter onChange={this.debounceonSearch} />
            </Grid>
            <Grid item xs={12}>
              <NewsCardFeatured pathNews={this.props.match.path} criteria={{category_actu: 'NOTeconomique'}}/>
            </Grid>
            {news.map(n => {
                return (
                  <Grid item xs={12} md={4} key={`news-grid-${n.id}`}>
                    <NewsCard key={`news-${n.id}`} entity={n} pathNews={this.props.match.path} withChip={true}/>
                  </Grid>
                )
              })
            }
            {news.length < totalSize &&
              <Grid item xs={12} style={{textAlign: "center"}}>
                <Btn
                  color='primary'
                  variant='contained'
                  loading={isFetching}
                  onClick={() => this.loadMoreNews(news.length)}
                >{t.load_more}</Btn>
              </Grid>
            }
          </Grid>
        }
        {!news &&
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="body2" align="center">{t.news_no_post}</Typography>
            </Grid>
          </Grid>
        }
      </Page>
    )
  }

  @autobind
  private loadMoreNews(offset){
    const {loadMore, criteria} = this.props
    const newsCriteria = {...criteria}
    newsCriteria.offset = offset
    loadMore(newsCriteria)
  }

  @autobind
  private filterByCategories(values: any){
    const filter = {} as NewsCriteria;
    filter.category_actu_nuage = values.get('actu-nuage')
    filter.category_actu = values.get('actu').length > 0 ? values.get('actu') + ",NOTeconomique" : "NOTeconomique"
    filter.category_produit = values.get('produit')
    filter.category_principale = values.get('principale')
    this.props.search(filter)
    
  }

  private debounceonSearch = debounce(this.filterByCategories, 300)

}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
    criteria: state.paginate.news.criteria,
    news: state.paginate.news.entities,
    isFetching: state.paginate.news.isFetching,
    totalSize: state.paginate.news.total_size
});

const dispatch2props = (dispatch: any) => ({
    updateObjectCriteria: (obj: any) => dispatch(actions.updateCriteriaByObject(obj)),
    updateCriteria: (name: string, value: any) => dispatch(actions.updateCriteria(name, value)),
    loadMore: (c: NewsCriteria) => dispatch(fetchMoreNews(c)),
    search: (c: NewsCriteria) => dispatch(fetchNews(c))
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(News)



// WEBPACK FOOTER //
// ./src/page/Consumer/News/News.tsx